import { Category } from '../types/category.type'
import { Topic } from '../types/topic.type'
import { Jurisdition } from '../types/jurisdiction.type'
import { InformationType } from '../types/information-type.type'
import { Information } from '../types/information.type'
import { Source } from './market.type';


export class RegulatoryActivityModel {
  Categories: Category[]=[];
  Topics: Topic[]=[];
  Jurisdictions: Jurisdition[]=[];
  InformationTypes: InformationType[]=[];
  Information: Information[]=[];
  New: boolean;
  From: Date;
  To: Date;
  Sources: Source[]=[];
  PageNumber: number;
  PageSize: number;
  Total: number;
  NewItems: number;
  AllTimeTotal :number;
}
